/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_Secure_ConnectionInputs */

const en_mobile_upload_error_secure_connection = /** @type {(inputs: Mobile_Upload_Error_Secure_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure connection failed. Please try again.`)
};

const es_mobile_upload_error_secure_connection = /** @type {(inputs: Mobile_Upload_Error_Secure_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falló la conexión segura. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Secure connection failed. Please try again." |
*
* @param {Mobile_Upload_Error_Secure_ConnectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_secure_connection = /** @type {((inputs?: Mobile_Upload_Error_Secure_ConnectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_Secure_ConnectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_secure_connection(inputs)
	return en_mobile_upload_error_secure_connection(inputs)
});